import { EducationLevel } from '../../participantEnums';
import { useTranslation } from 'react-i18next';

export const useEducationLevels = () => {
  const { t } = useTranslation('common');
  return [
    {
      value: EducationLevel.HIGH_SCHOOL,
      label: t('participants.enums.education.HIGH_SCHOOL'),
    },
    {
      value: EducationLevel.ALUM,
      label: t('participants.enums.education.ALUM'),
    },
    {
      value: EducationLevel.PROFESSIONAL_DEGREE,
      label: t('participants.enums.education.PROFESSIONAL_DEGREE'),
    },
    {
      value: EducationLevel.ASSOCIATE_DEGREE,
      label: t('participants.enums.education.ASSOCIATE_DEGREE'),
    },
    {
      value: EducationLevel.HIGH_SCHOOL_GRAD,
      label: t('participants.enums.education.HIGH_SCHOOL_GRAD'),
    },
    {
      value: EducationLevel.MASTER_DEGREE,
      label: t('participants.enums.education.MASTER_DEGREE'),
    },
    {
      value: EducationLevel.DOCTORATE_DEGREE,
      label: t('participants.enums.education.DOCTORATE_DEGREE'),
    },
  ];
};
